import React, { useState, useEffect } from "react";
import { Card, Table } from 'react-bootstrap';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Link } from "react-router-dom";
import { Sidebar } from 'primereact/sidebar';
import { Calendar } from 'primereact/calendar';
import axios from "axios";
import moment from "moment";
import { useAuth } from '../context/AuthContext';
import config from '../config';
import { Badge } from 'primereact/badge';
import { toWords } from "number-to-words";
const Client_for_invoice = ({ clientId }) => {
    const { accessToken } = useAuth();
    const [visibleRight, setVisibleRight] = useState(false);
    const [date, setDate] = useState(new Date());
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const currencySymbols = {
        INR: "₹ ",
        USD: "$ ",
        GBP: "£ ",
        EUR: "€ ",
        AED: "د.إ ",
        AUD: "A$ ",
        CAD: "C$ "
    };

    const getCurrencySymbol = (currencyCode) => {
        return currencySymbols[currencyCode] || currencyCode; // Default to currency code if not found
    };
    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/InvoiceRoutes/invoices/${clientId}`, {
                    params: {
                        month: date.getMonth() + 1,
                        year: date.getFullYear()
                    },
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });

                if (response.status === 200) {
                    setInvoices(response.data);
                } else {
                    setInvoices([]);
                }
            } catch (error) {
                console.error('Error fetching invoices:', error);
                setInvoices([]);
            } finally {
                setLoading(false);
            }
        };

        if (clientId) {
            fetchInvoices();
        }
    }, [clientId, date, accessToken]);


    return (
        <>
            <Card className='shadow-0'>
                <Card.Header className='d-flex justify-content-between align-items-center py-0 border-0'>

                    <small>Total Invoice : <b>{invoices.length}</b></small>
                    <Calendar
                        value={date}
                        onChange={(e) => setDate(e.value)}
                        view="month"
                        dateFormat="mm/yy"
                        style={{ width: '100px' }}
                    />
                </Card.Header>
                <Card.Body>
                    {loading ? (
                        <p>Loading invoices...</p>
                    ) : invoices.length === 0 ? (
                        <p>No invoices found.</p>
                    ) : (
                        <Table className='clpro_invtable'>
                            <tbody>
                                {invoices.map((invoice) => (
                                    <tr key={invoice.invoice_id}>
                                        <td>
                                            <Link
                                                onClick={() => {
                                                    setSelectedInvoice(invoice); // Set the selected invoice
                                                    setVisibleRight(true); // Show the sidebar/modal
                                                }}
                                                className='text-blue'
                                            >
                                                <b>#{invoice.invoice_code} </b>
                                            </Link>
                                        </td>
                                        <td>
                                            <h6>{invoice.template?.header_text || 'N/A'}</h6>
                                            <p>Issue: {new Date(invoice.issue_date).toLocaleDateString('en-GB')}</p>
                                        </td>
                                        <td>
                                            <small className='d-block'>Tax</small>
                                            {invoice.tax_type || 'N/A'}
                                        </td>
                                        <td>
                                            <small className='d-block'>Amount</small>
                                            {invoice.total || '0'}
                                        </td>
                                        <td>
                                            <Badge
                                                value={invoice.Payment_status}
                                                severity={
                                                    invoice.Payment_status === 'Payment_Completed' ? 'success' :
                                                        invoice.Payment_status === 'Partial_Payment' ? 'info' :
                                                            invoice.Payment_status === 'Refunded' ? 'danger' :
                                                                'warning' // Default for 'Payment_due'
                                                }
                                            />

                                        </td>
                                        <td>
                                            <Button
                                                title='View'
                                                icon='pi pi-eye'
                                                severity='help'
                                                outlined
                                                className='border-0 p-0'
                                                onClick={() => {
                                                    setSelectedInvoice(invoice); // Set the selected invoice
                                                    setVisibleRight(true); // Show the sidebar/modal
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Card.Body>
            </Card>

            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '50vw' }}>
                {selectedInvoice && (
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '0', fontFamily: 'Roboto', background: '#fff' }}>
                        <thead>
                            <tr style={{ borderBottom: '1px solid #ddd' }}>
                                <td colspan="3" style={{ padding: '10px', Width: '300px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={selectedInvoice.logo_url || require("../assets/images/logo.png")} alt="Company Logo" style={{ height: '170px', width: '170px', objectFit: 'contain' }} />
                                        <div style={{ width: 'calc(100% - 120px)', marginLeft: '30px' }}>
                                            <h2 style={{ margin: '5px 0 0 0', fontSize: '20px', color: '#494949', textTransform: 'uppercase' }}>The Graphē</h2>
                                            <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: '400', color: '#858585' }}>A Design Studio</p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', lineHeight: '20px', color: '#494949', width: '200px' }}>{selectedInvoice.template?.company_address || "N/A"}</p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>GSTIN No. : <b>{selectedInvoice.template?.GSTIN}</b></p>
                                            <p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>MSME No. : <b>{selectedInvoice.MSME_Number}</b> <small style={{ color: '#858585' }}>({selectedInvoice.MSME_Type})</small></p>
                                            {selectedInvoice.lut && (<p style={{ margin: '0 0 6px 0', fontSize: '13px', color: '#494949' }}>LUT No. : <b>{selectedInvoice.Lut_Arn_No}</b></p>)}
                                        </div>
                                    </div>
                                </td>
                                <td style={{ padding: "10px", textAlign: "right", verticalAlign: "top", width: "280px", paddingLeft: "65px" }} colspan="2" >
                                    <h3 style={{ margin: "5px 0 10px 0", fontSize: "26px", color: "#000" }}>{selectedInvoice.template_name}</h3>

                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" style={{ padding: "8px 0" }}></td>
                            </tr>
                            <tr>
                                <td colSpan="2" style={{ padding: "10px 15px 10px 10px", verticalAlign: "top" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Bill To :</p>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.bill_name}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Poc : </span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.poc}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Email : </span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.email || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.phone || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>GSTIN :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.gstin || "N/A"}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)" }}>
                                                {selectedInvoice.specificInvoices?.bill_address || "N/A"}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td colSpan="2" style={{ padding: "10px", verticalAlign: "top" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "14px", fontWeight: 600 }}>Ship To :</p>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Name : </span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.shipping_name}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Ph. No. :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 60px)" }}>
                                                {selectedInvoice.shipping_phone}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", lineHeight: "1.3", marginTop: "5px" }}>
                                            <span style={{ width: "60px", marginRight: "5px" }}>Address :</span>
                                            <span style={{ fontWeight: 400, paddingLeft: "5px", width: "calc(80% - 60px)", }}>
                                                {selectedInvoice.shipping_address}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td colSpan="1" style={{ padding: "10px", verticalAlign: "top", width: "200px" }}>
                                    <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Invoice # :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {selectedInvoice.invoice_code}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Issue Date :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {new Date(selectedInvoice.issue_date).toLocaleDateString("en-GB")}
                                            </span>
                                        </li>
                                        <li style={{ display: "flex", justifyContent: "start" }}>
                                            <span style={{ width: "70px", marginRight: "5px" }}>Due Date :</span>
                                            <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 70px)" }}>
                                                {new Date(selectedInvoice.due_date).toLocaleDateString("en-GB")}
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5" style={{ padding: '10px 0' }}></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ backgroundColor: '#e7e7e7', textAlign: 'left' }}>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '230px' }}>Description</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>SAC/HSN</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Rate</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '130px' }}>Qty</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px', fontWeight: '600', width: '100px' }}>Sub Total</th>
                            </tr>
                            {selectedInvoice?.invoiceProducts?.map((product, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        <span style={{ display: 'block', marginBottom: '3px' }}>{index + 1}. {product.description}</span>
                                        {product.Remarks && (
                                            <small style={{ fontSize: '11px', lineHeight: '1.2' }} className="text-secondary d-block">
                                                <b>Remarks :</b> {product.Remarks}
                                            </small>
                                        )}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {product.hsn ? `HSN-${product.hsn}` : product.sac_code ? `SAC-${product.sac_code}` : '-'}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {getCurrencySymbol(selectedInvoice.currency)} {product.price}
                                    </td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>{product.quantity}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '13px' }}>
                                        {getCurrencySymbol(selectedInvoice.currency)} {product.subtotal_price}
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <th colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Subtotal:</th>
                                <th style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.sub_total}</th>
                            </tr>
                            {selectedInvoice.tax_type === "Cgst+Sgst" && (
                                <>
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>CGST ({selectedInvoice.cgst}%):</td>
                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.cgst_value.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>SGST ({selectedInvoice.sgst}%):</td>
                                        <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.sgst_value.toFixed(2)}</td>
                                    </tr>
                                </>
                            )}
                            {selectedInvoice.tax_type === "Igst" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>IGST ({selectedInvoice.igst}%):</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.igst_value.toFixed(2)}</td>
                                </tr>
                            )}
                            {selectedInvoice.tax_type === "GST" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>GST ({selectedInvoice.gst}%):</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.gst_value.toFixed(2)}</td>
                                </tr>
                            )}
                            {selectedInvoice.supplyAttractReverses === "Yes" && (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Supply Attract Reverse Charge :</td>
                                    <td style={{ border: '1px solid #ddd', padding: '6px 10px', fontSize: '14px' }}>Yes</td>
                                </tr>
                            )}
                            <tr style={{ backgroundColor: '#e7e7e7' }}>
                                <td colSpan={4} style={{ textAlign: 'right', fontWeight: '600', border: '1px solid #ddd', padding: '6px 10px', fontSize: '18px' }}>Total:</td>
                                <td style={{ border: '1px solid #ddd', fontWeight: '600', padding: '6px 10px', fontSize: '18px' }}>{getCurrencySymbol(selectedInvoice.currency)} {selectedInvoice.total}</td>
                            </tr>
                            <tr>
                                <td colSpan={5} style={{ padding: '10px 10px 10px 0' }}>
                                    <p style={{ margin: 0, fontSize: '13px' }}>
                                        Total amount (in words) : <span style={{ fontWeight: '500', paddingLeft: '5px' }}>{selectedInvoice.currency} {toWords(selectedInvoice.total)} Only.</span>
                                    </p>
                                </td>
                            </tr>
                            {selectedInvoice.remarks && (
                                <tr>
                                    <td colSpan={5} style={{ padding: '10px 10px 10px 0', verticalAlign: 'top' }}>
                                        <p style={{ margin: 0 }}>
                                            <span style={{ fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>Remarks :</span>
                                            <span style={{ fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>{selectedInvoice.remarks}</span>
                                        </p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="5" style={{ padding: "10px 0" }}></td>
                            </tr>
                            <tr>
                                <td colSpan="3" style={{ padding: "15px 10px", verticalAlign: "top", borderTop: "1px solid #ddd" }}>
                                    <div style={{ display: "flex" }}>
                                        <div style={{ paddingRight: "10px", textAlign: "center" }}>
                                            <p style={{ margin: "0 0 6px 0", fontSize: "12px", fontWeight: 600 }}>Pay Using UPI :</p>
                                            <img
                                                src="https://ik.imagekit.io/blackboxv2/Graphe-logo/Graphe%CC%84%20QR%20Code.png?updatedAt=1743494152821"
                                                alt="UPI QR Code"
                                                style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                            />
                                            <small style={{ display: "block", fontSize: "12px", fontWeight: 400 }}>
                                                yashashwi.malani@okhdfcbank
                                            </small>
                                        </div>

                                        <div style={{ width: "calc(100% - 120px)", paddingLeft: "10px", borderLeft: "1px solid #ddd" }}>
                                            <p style={{ margin: "0 0 6px 0", fontSize: "13px", fontWeight: 600 }}>Bank Details :</p>
                                            <ul style={{ listStyle: "none", margin: 0, padding: 0, fontSize: "13px", lineHeight: "24px" }}>
                                                <li style={{ display: "flex", marginBottom: "3px" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C Name :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)", lineHeight: 1.3 }}>
                                                        {selectedInvoice.template?.company_name || "N/A"}
                                                        <small style={{ margin: "2px 0 0px 0", fontSize: "11px", fontWeight: 400, color: "#858585", display: "block" }}>
                                                            Pay By CHEQUE/DD/RTGS/NEFT
                                                        </small>
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Bank :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.bank_name || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>A/C NO :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.account_number || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>IFSC :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.ifsc_code || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Branch :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.bank_branch || "N/A"}
                                                    </span>
                                                </li>
                                                <li style={{ display: "flex" }}>
                                                    <span style={{ width: "80px", marginRight: "5px" }}>Swift Code :</span>
                                                    <span style={{ fontWeight: 500, paddingLeft: "5px", width: "calc(100% - 80px)" }}>
                                                        {selectedInvoice.template?.swift_code || "N/A"}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                                <td style={{ padding: "15px 10px", textAlign: "right", verticalAlign: "top", borderTop: "1px solid #ddd" }} colSpan="2">
                                    <div style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                                        <div>
                                            <small style={{ marginRight: "50px" }}>
                                                <img
                                                    src="https://ik.imagekit.io/blackboxv2/Graphe-logo/stamp.jpeg?updatedAt=1737015027907"
                                                    alt="Stamp"
                                                    style={{ width: "80px", height: "80px", objectFit: "contain" }}
                                                />
                                            </small>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <p style={{ display: "block", fontSize: "14px", margin: "0 0 18px 0", fontWeight: 500 }}>
                                                <small>For The Graphē</small>
                                            </p>
                                            <img src={selectedInvoice.signature_url} alt="Signature" style={{ width: "80px", height: "80px" }} />
                                            <p style={{ display: "block", fontSize: "14px", margin: "18px 0 0 0", fontWeight: 400 }}>
                                                <small>Authorised Signatory</small>
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ backgroundColor: "#f7f7f7" }}>
                                <td colSpan="5" style={{ padding: "10px 10px 0 10px", color: "#575757" }}>
                                    <p style={{ margin: "0 0 5px 0", fontSize: "13px", fontWeight: 600 }}>
                                        <span>Terms and Conditions : </span>
                                    </p>
                                    {[
                                        "Payment: Due within 7 days. Late payments attract interest as per the MSME Act, 2006.",
                                        "Interest on Late Payment: As per Section 16 of the MSME Act, 2006, delays beyond 45 days from the invoice date will attract interest at *24% P.A*",
                                        "Intellectual Property: Final designs are transferred upon full payment. Unpaid concepts remain the agency’s property.",
                                        "Revisions & Scope: Additional revisions beyond the agreed scope may be chargeable.",
                                        "Taxes: GST applicable as per law. Any tax changes are the client’s responsibility.",
                                        "Confidentiality: Both parties must maintain confidentiality unless agreed otherwise.",
                                        "Jurisdiction: Disputes fall under Kolkata, West Bengal, jurisdiction.",
                                        "Force Majeure: The agency isn’t liable for delays due to unforeseen circumstances."
                                    ].map((text, index) => (
                                        <p key={index} style={{ margin: "0 0 5px 0", fontSize: "12px", fontWeight: 400 }}>{index + 1}. {text}</p>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5" style={{ backgroundColor: "#313030", padding: "10px 15px", textAlign: "center" }}>
                                    <small style={{ fontSize: "13px", fontWeight: 400, color: "#fff" }}>
                                        Call: {selectedInvoice.template?.contact_no || "N/A"} &nbsp;| &nbsp;
                                        Email: <a href={`mailto:${selectedInvoice.template?.email}`} style={{ color: "#fff" }}>{selectedInvoice.template?.email || "N/A"}</a>
                                    </small>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )}
            </Sidebar>

        </>
    );
};

export default Client_for_invoice;